<template>
  <div id="app">
    <router-view :layout.sync="layout" />
    <portal-target name="modal" multiple />
    <portal-target name="minimised-cards-container" multiple />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/base/Header.vue';
import { handleRedirectDestination } from '@/utils/localstorage.util';
import { mixins } from 'vue-class-component';
import { SessionHandlerMixin } from '@/utils/session-handler.mixin';
import { ApiResponseErrorHandlerMixin } from '@/utils/api-response-error-handler-mixin.component';

@Component({
  components: { Header },
})
export default class App extends mixins(
  SessionHandlerMixin,
  ApiResponseErrorHandlerMixin,
) {
  private layout = 'div';

  public created() {
    handleRedirectDestination(this.$router);
  }
}
</script>
<style lang="scss">
// Todo: Add to prepend data in vue.config.js
@import 'jbi-shared/scss/styles.scss';
@import 'assets/scss/paces_global';
@import 'assets/scss/flex';
@import 'assets/scss/spacing';
@import 'assets/scss/helper';
</style>
